import UIkit from "uikit";

export const WORK_ORDER_ADD_ID = "work-order-add";
const PERSISTENT_MODAL_IDS = new Set([
  WORK_ORDER_ADD_ID,
  "work-order-delete",
]);

const isPersistentModal = (el) =>
  PERSISTENT_MODAL_IDS.has(el.id) || el.classList.contains("portal-container");

/**
 * UIkit.modal.dialog() can leave a short-lived uk-modal layer above the
 * work-order offcanvas and swallow clicks (manager/assignee/type controls).
 * Only tear down ephemeral dialog() shells — not React Dialog portals.
 */
export function clearStaleUIKitModalOverlays() {
  document.documentElement.classList.remove("uk-modal-page");
  document.body.classList.remove("uk-modal-page");

  document.querySelectorAll("body > .uk-modal").forEach((el) => {
    if (isPersistentModal(el)) return;
    try {
      const instance = UIkit.modal(el);
      if (instance?.isToggled?.()) {
        instance.hide();
      }
    } catch (_) {
      /* ignore */
    }
    if (el.parentNode) {
      el.parentNode.removeChild(el);
    }
  });
}

/** Open the shared work-order add/edit offcanvas without a blocking modal stack. */
export function openWorkOrderAddPanel() {
  const el = document.getElementById(WORK_ORDER_ADD_ID);
  if (!el) return;

  clearStaleUIKitModalOverlays();
  try {
    UIkit.modal(el).hide();
  } catch (_) {
    /* ignore — clears stale modal overlay from older code paths */
  }
  UIkit.offcanvas(el).show();
}
